import { render, staticRenderFns } from "./points_list.vue?vue&type=template&id=79d67d99&scoped=true&"
import script from "./points_list.vue?vue&type=script&lang=js&"
export * from "./points_list.vue?vue&type=script&lang=js&"
import style0 from "./points_list.vue?vue&type=style&index=0&id=79d67d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d67d99",
  null
  
)

export default component.exports